import React, { useContext } from "react";

import styled from "styled-components";

import Tag from "components/Tag";

import { COLOR_CATEGORIES } from "constants/collection";

import StoreContext from "context/Store";

import { translateSize } from "utils/product";

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${(p) => p.theme.media.minWidth("tablet")} {
    min-height: 40px;
  }
`;

const Link = styled.button`
  ${(p) => p.theme.typography.tXSmall};
  line-height: 1em;
  height: 30px;
  margin: 0 0 10px 10px;

  span {
    border-bottom: solid 1px ${(p) => p.theme.colors.white};
  }

  &:hover {
    border-bottom-color: transparent;
  }
`;

const ActiveFilters = (props) => {
  const { title } = props;

  const {
    collection: { filters, toggleFilter, clearFilters, sizeLocale },
  } = useContext(StoreContext);
  const group = "Color";
  const selectOption = (optionName) =>
    filters.find((filter) => {
      if (filter.includes(optionName)) {
        return true;
      }
    });

  const colorFilters = (filtered) => {
    return Object.keys(COLOR_CATEGORIES).map((value, index) => {
      const selectedColor = `variant:${group}:${value}`;

      const selectedValues = Object.values(
        COLOR_CATEGORIES[value].map((color) => `variant:${group}:${color}`)
      );

      return (
        <Tag
          key={index}
          text={value}
          active={filtered.includes(selectedColor)}
          onClick={() => selectedValues.map((item) => toggleFilter(item))}
        />
      );
    });
  };

  return (
    <Tags>
      {selectOption("Color") && colorFilters(filters)}

      {selectOption("Size") &&
        filters.map((filter, i) => {
          const group = filter.split(":")[1];
          const value = filter.split(":")[2];
          if (filter.includes("Size")) {
            return (
              <Tag
                key={i}
                text={translateSize(
                  value.replace("'", "’").replace(title, ""),
                  sizeLocale.value,
                  group.replace(" Size", "")
                )}
                active={true}
                onClick={() => toggleFilter(filter)}
              />
            );
          }
        })}

      {filters.length > 0 && (
        <Link onClick={clearFilters}>
          <span>Clear All</span>
        </Link>
      )}
    </Tags>
  );
};

export default ActiveFilters;
